/** Whether the page runs as the installed app or in a browser tab. */
export function displayMode(): 'standalone' | 'browser' {
  try {
    return window.matchMedia('(display-mode: standalone)').matches ||
      (navigator as Navigator & { standalone?: boolean }).standalone === true
      ? 'standalone'
      : 'browser';
  } catch {
    return 'browser';
  }
}
